import api from '@/api/api';
import { User } from '@/interfaces/User';

export const getMeUser: () => Promise<User> = async () => {
  try {
    const response = await api.get('/user');
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.status);
  }
};
